var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0024 13.4263C12.5405 13.4263 13.0571 13.213 13.4382 12.8331L23.6515 2.61982C24.1201 2.15119 24.1201 1.39139 23.6515 0.922762C23.417 0.688322 23.1097 0.571165 22.8024 0.57129C22.4952 0.571166 22.1879 0.688323 21.9534 0.922762L12.0024 10.8737L2.05146 0.922761C1.81702 0.688322 1.50971 0.571165 1.20244 0.571289C0.895171 0.571165 0.587863 0.688322 0.353426 0.922761C-0.115204 1.39139 -0.115204 2.15119 0.353426 2.61982L10.5667 12.8331C10.9477 13.213 11.4644 13.4263 12.0024 13.4263Z","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 25 14","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
